import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Password from '@axa-asia/emma-stylesheet/lib/components/Password';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import './style.scss';
import CustomerProfileItem from '../../components/CustomerProfileItem';
import LoadingView from '../../../../components/LoadingView';
import {
  sequenceValidatorCheck,
  validatePassword,
  validateRetypePassword,
} from '../../../../utils/common';
import { t } from '../../../../locales';
import { getCustomerProfilePasswordConfig } from '../../selectors/customerProfileResetPasswordSelectors';
import { getSendOtpLoading } from '../../selectors/customerProfileVerifySelectors';
import { resolveLocalizedText, getLoginId } from '../../../../utils';
import { extractCountryCode } from '../../../../utils/common';
import { goto } from '../../../../actions/historyActions';
import { updateResetPassword } from '../../actions/customerResetPasswordAction';
import { sendOtp } from '../../actions/customerProfileVerifyAction';
import {
  FEATURE_NAME_PASSWORD,
  RESET_PASSWORD_EMAIL_FEATURE_ID,
  VERIFY_SEND_EMAIL_OTP_DEFAULT_ERROR_CODE,
  VERIFY_SEND_MOBILE_OTP_DEFAULT_ERROR_CODE,
} from '../../constants/constants';
import { getToken } from '../../../../selectors/authSelectors';
import { getCustomerProfileCurrentUpdateKey } from '../../selectors/customerProfileResetUNOrPWSelectors';
import { select } from '../../../../stores';
import { callBackErrorCodePage } from '../../utils';
import loadingIcon from '../../../../assets/images/loading-white.png';
import { ChangeContactView } from '../../components/ChangeContactView';
import browserHistory from '../../../../stores/browserHistory';
import { setNavigationBarTitle } from '../../../../utils/AppUtils';

export interface CustomerResetPasswordContainerProps {
  title: string;
  passwordFormInputLabel: string;
  passwordFormInputPlaceholder: string;
  retypePasswordFormInputLabel: string;
  retypePasswordFormInputPlaceholder: string;
  passwordRequirements: string;
  passwordMustRequirements: string;
  passwordButton: string;
  rulesItem1: string;
  rulesItem2: string;
  rulesItem3: string;
  rulesItem4: string;
  rulesItem5: string;
  rulesItem6: string;
  isSubmitLoading: boolean;
  curUpdateKey: string;
  onUpdateResetPassword: (params: any) => void;
  onSendOtp: (params: any) => void;
  resetPasswordStepContext: any;
}

export interface CustomerResetPasswordContainerState {
  passwordValue: string;
  retypePasswordValue: string;
  isPasswordCorrect: boolean;
  isRetypePasswordCorrect: boolean;
  one: boolean;
  two: boolean;
  three: boolean;
  four: boolean;
  five: boolean;
  six: boolean;
  errorMsg: string;
  errorRetypeMsg: string;
}

export class CustomerResetPasswordContainer extends Component<
  CustomerResetPasswordContainerProps,
  CustomerResetPasswordContainerState
> {
  constructor(props: any) {
    super(props);
    // state 'one' for pasword length between 8 -16 characters
    // state 'two' to check Upercase
    // state 'three' to check Lowercase
    // state 'four' to check number
    // state 'five' to special character
    // state 'six' added as password sequence validator flag
    this.state = {
      passwordValue: '',
      retypePasswordValue: '',
      isPasswordCorrect: false,
      isRetypePasswordCorrect: false,
      one: false,
      two: false,
      three: false,
      four: false,
      five: false,
      six: false,
      errorMsg: '',
      errorRetypeMsg: '',
    };
  }

  componentDidMount() {
    const { curUpdateKey, title } = this.props;
    !curUpdateKey && goto('emma-customer-profile-resetusenameorpassword');

    setNavigationBarTitle(title);
  }

  onChangePassword = (e: any) => {
    const password = e.target.value;
    const { retypePasswordValue } = this.state;
    const errorRetypeMsg = validateRetypePassword(
      retypePasswordValue,
      password,
    );
    const errorMsg = validatePassword(password, null, 8, 16, null, null, null);
    this.setState({
      passwordValue: password,
      errorMsg: errorMsg ? t(errorMsg) : '',
      isPasswordCorrect: errorMsg === '',
      errorRetypeMsg: errorRetypeMsg ? t(errorRetypeMsg) : '',
      isRetypePasswordCorrect: errorRetypeMsg === '',
    });
    // Check length
    if (
      password.length > 7 &&
      password.length <= 17 &&
      !/.*((.)\2{2}?(?!\2))/g.test(password)
    ) {
      this.setState({
        one: true,
      });
    } else {
      this.setState({
        one: false,
      });
    }
    // Check Upper case
    if (password !== password.toLowerCase()) {
      this.setState({
        two: true,
      });
    } else {
      this.setState({
        two: false,
      });
    }
    // Check Lower case
    if (password !== password.toUpperCase()) {
      this.setState({
        three: true,
      });
    } else {
      this.setState({
        three: false,
      });
    }
    // Check Number
    const numberReg = new RegExp('.*\\d+.*');
    if (numberReg.test(password)) {
      this.setState({
        four: true,
      });
    } else {
      this.setState({
        four: false,
      });
    }
    // Check Special
    const specialReg = new RegExp(
      '.*[`\\[\\]\\-!~@#$%^&*_()+=,.?":;{}|<>\\\\/\'].*',
    );
    if (specialReg.test(password)) {
      this.setState({
        five: true,
      });
    } else {
      this.setState({
        five: false,
      });
    }
    // Check Sequence Validator
    if (password && sequenceValidatorCheck(password)) {
      this.setState({
        six: true,
      });
    } else {
      this.setState({
        six: false,
      });
    }
  };

  onChangeRetypePassword = (e: any) => {
    const { passwordValue } = this.state;
    const retypePasswordValue = e.target.value;
    const errorRetypeMsg = validateRetypePassword(
      retypePasswordValue,
      passwordValue,
    );
    this.setState({
      retypePasswordValue,
      errorRetypeMsg: errorRetypeMsg ? t(errorRetypeMsg) : '',
      isRetypePasswordCorrect: errorRetypeMsg === '',
    });
  };

  isEnableSubmitButton = () => {
    const { isPasswordCorrect, isRetypePasswordCorrect } = this.state;
    const isEnableSubmitButton = isPasswordCorrect && isRetypePasswordCorrect;
    return isEnableSubmitButton;
  };

  onSubmit = () => {
    let mobileNumber, countryCode;
    const { onSendOtp, onUpdateResetPassword } = this.props;
    const { passwordValue } = this.state;
    const token = select(getToken);
    const loginId = getLoginId(token);
    const isEmail = loginId.includes('@');
    if (loginId && !isEmail) {
      const CountryCodeObj = extractCountryCode(loginId);
      mobileNumber = CountryCodeObj.mobileNumber;
      countryCode = CountryCodeObj.countryCode;
    }
    const callBack = () => {
      onUpdateResetPassword(passwordValue);
      goto('emma-customer-profile-reset-verify');
    };
    const defaultErrorCode = isEmail
      ? VERIFY_SEND_EMAIL_OTP_DEFAULT_ERROR_CODE
      : VERIFY_SEND_MOBILE_OTP_DEFAULT_ERROR_CODE;
    const sendData = {
      callBack,
      featureName: FEATURE_NAME_PASSWORD,
      email: isEmail ? loginId : null,
      mobile: !isEmail ? mobileNumber : null,
      countryCode,
      callBackErrorCodePage,
      defaultErrorCode,
      featureId: RESET_PASSWORD_EMAIL_FEATURE_ID,
      password: passwordValue,
    };
    onSendOtp(sendData);
  };

  onGoBack = () => {
    browserHistory.goBack();
  };

  render() {
    const { one, two, three, four, five, six, errorMsg, errorRetypeMsg } =
      this.state;
    const {
      title,
      passwordFormInputLabel,
      passwordFormInputPlaceholder,
      retypePasswordFormInputLabel,
      retypePasswordFormInputPlaceholder,
      passwordRequirements,
      passwordMustRequirements,
      passwordButton,
      rulesItem1,
      rulesItem2,
      rulesItem3,
      rulesItem4,
      rulesItem5,
      rulesItem6,
      isSubmitLoading,
      resetPasswordStepContext,
    } = this.props;

    const isEnableSubmitButton = this.isEnableSubmitButton();
    return isSubmitLoading ? (
      <LoadingView />
    ) : (
      <div className="customer-reset-password-container">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={title ? resolveLocalizedText(title) : ''}
          stepContext={resetPasswordStepContext}
          activeIndex={0}
        >
          <div className="emma-stylesheet-grid-system">
            <div className="row content-align-right-wrap">
              <div className="customer-reset-password-container-password">
                <div className="customer-reset-password-container-password-label">
                  {passwordFormInputLabel}
                </div>
                <Password
                  childrenClassName={`customer-reset-password-container-password-input ${
                    errorMsg
                      ? 'customer-reset-password-container-password-input-border-error'
                      : ''
                  }`}
                  helpText={errorMsg}
                  helpTextClass={
                    errorMsg
                      ? 'customer-reset-password-container-password-input-error'
                      : ''
                  }
                  inputClassName="col-12"
                  placeholder={passwordFormInputPlaceholder}
                  onChange={(e: any) => {
                    this.onChangePassword(e);
                  }}
                />
              </div>

              <div className="customer-reset-password-container-password">
                <div className="customer-reset-password-container-password-label">
                  {retypePasswordFormInputLabel}
                </div>
                <Password
                  childrenClassName={`customer-reset-password-container-password-input ${
                    errorRetypeMsg
                      ? 'customer-reset-password-container-password-input-border-error'
                      : ''
                  }`}
                  helpText={errorRetypeMsg}
                  helpTextClass={
                    errorRetypeMsg
                      ? 'customer-reset-password-container-password-input-error'
                      : ''
                  }
                  inputClassName="col-12"
                  placeholder={retypePasswordFormInputPlaceholder}
                  onChange={(e: any) => {
                    this.onChangeRetypePassword(e);
                  }}
                />
              </div>
            </div>
            <div className="row customer-reset-password-container-requirement">
              <div className="col-12 customer-reset-password-container-requirement-title">
                {passwordRequirements}
              </div>
              <div className="col-12 customer-reset-password-container-requirement-ul">
                <CustomerProfileItem text={rulesItem1} correct={one} />
                <CustomerProfileItem text={rulesItem2} correct={six} />
              </div>
            </div>
            <div className="row customer-reset-password-container-requirement">
              <div className="col-12 customer-reset-password-container-requirement-title">
                {passwordMustRequirements}
              </div>
              <div className="col-12 customer-reset-password-container-requirement-ul">
                <CustomerProfileItem text={rulesItem3} correct={two} />
                <CustomerProfileItem text={rulesItem4} correct={three} />
                <CustomerProfileItem text={rulesItem5} correct={four} />
                <CustomerProfileItem text={rulesItem6} correct={five} />
              </div>
            </div>
            <div className="customer-reset-usename-container-content-section-form-button">
              <div className="content-align">
                <button
                  data-enable-ga={isEnableSubmitButton && !isSubmitLoading}
                  data-ga-type="button"
                  className={
                    isEnableSubmitButton && !isSubmitLoading
                      ? 'emma-stylesheet-primary-default-button'
                      : 'emma-stylesheet-primary-secondary-default-disabled-button'
                  }
                  disabled={!isEnableSubmitButton || isSubmitLoading}
                  type="submit"
                  onClick={this.onSubmit}
                >
                  {isSubmitLoading && <img src={loadingIcon} alt="loading" />}
                  {passwordButton}
                </button>
              </div>
            </div>
          </div>
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const resetPasswordLabels = getCustomerProfilePasswordConfig(state);
    const title =
      resetPasswordLabels && resetPasswordLabels.title
        ? resolveLocalizedText(resetPasswordLabels.title)
        : '';

    // for password
    const passwordFormLabels = _.get(
      resetPasswordLabels,
      `passwordLabels.formLabels`,
      {},
    );
    const passwordFormInputLabel =
      passwordFormLabels && passwordFormLabels.inputLabel
        ? resolveLocalizedText(passwordFormLabels.inputLabel)
        : '';
    const passwordFormInputPlaceholder =
      passwordFormLabels && passwordFormLabels.inputPlaceholder
        ? resolveLocalizedText(passwordFormLabels.inputPlaceholder)
        : '';
    // for retype password
    const retypePasswordFormLabels = _.get(
      resetPasswordLabels,
      `retypePasswordLabels.formLabels`,
      {},
    );
    const retypePasswordFormInputLabel =
      retypePasswordFormLabels && retypePasswordFormLabels.inputLabel
        ? resolveLocalizedText(retypePasswordFormLabels.inputLabel)
        : '';
    const retypePasswordFormInputPlaceholder =
      retypePasswordFormLabels && retypePasswordFormLabels.inputPlaceholder
        ? resolveLocalizedText(retypePasswordFormLabels.inputPlaceholder)
        : '';

    // for passwordRules
    const passwordRules = _.get(resetPasswordLabels, `passwordRules`, {});
    const passwordRequirements =
      passwordRules && passwordRules.passwordRequirements
        ? resolveLocalizedText(passwordRules.passwordRequirements)
        : '';

    const passwordRequirementsRules = _.get(
      resetPasswordLabels,
      `passwordRules.passwordRequirementsRules`,
      {},
    );
    const rulesItem1 =
      passwordRequirementsRules && passwordRequirementsRules.item1
        ? resolveLocalizedText(passwordRequirementsRules.item1)
        : '';
    const rulesItem2 =
      passwordRequirementsRules && passwordRequirementsRules.item2
        ? resolveLocalizedText(passwordRequirementsRules.item2)
        : '';

    const passwordMustRequirements =
      passwordRules && passwordRules.passwordRequirements
        ? resolveLocalizedText(passwordRules.passwordMustRequirements)
        : '';
    const passwordMustRequirementsRules = _.get(
      resetPasswordLabels,
      `passwordRules.passwordMustRequirementsRules`,
      {},
    );
    const rulesItem3 =
      passwordMustRequirementsRules && passwordMustRequirementsRules.item1
        ? resolveLocalizedText(passwordMustRequirementsRules.item1)
        : '';
    const rulesItem4 =
      passwordMustRequirementsRules && passwordMustRequirementsRules.item2
        ? resolveLocalizedText(passwordMustRequirementsRules.item2)
        : '';
    const rulesItem5 =
      passwordMustRequirementsRules && passwordMustRequirementsRules.item3
        ? resolveLocalizedText(passwordMustRequirementsRules.item3)
        : '';
    const rulesItem6 =
      passwordMustRequirementsRules && passwordMustRequirementsRules.item4
        ? resolveLocalizedText(passwordMustRequirementsRules.item4)
        : '';

    const resetPasswordStepContext =
      resetPasswordLabels && resetPasswordLabels.resetPasswordStepContext
        ? resolveLocalizedText(resetPasswordLabels.resetPasswordStepContext)
        : '';
    const passwordButton =
      resetPasswordLabels && resetPasswordLabels.passwordButton
        ? resolveLocalizedText(resetPasswordLabels.passwordButton)
        : '';
    const isSubmitLoading = getSendOtpLoading(state);

    const curUpdateKey = getCustomerProfileCurrentUpdateKey(state);

    return {
      title,
      passwordFormInputLabel,
      passwordFormInputPlaceholder,
      retypePasswordFormInputLabel,
      retypePasswordFormInputPlaceholder,
      passwordRequirements,
      passwordMustRequirements,
      passwordButton,
      rulesItem1,
      rulesItem2,
      rulesItem3,
      rulesItem4,
      rulesItem5,
      rulesItem6,
      isSubmitLoading,
      curUpdateKey,
      resetPasswordStepContext,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onUpdateResetPassword: (params: any) =>
        dispatch(updateResetPassword(params)),
      onSendOtp: (params: any) => dispatch(sendOtp(params)),
    };
  }
}

export default connect(
  CustomerResetPasswordContainer.mapStateToProps,
  CustomerResetPasswordContainer.mapDispatchToProps,
)(CustomerResetPasswordContainer);
